import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
//components
import Input from "../../../../../components/input/Input";
import Panel from "../../../../../components/panel/panel";
import Select from "../../../../../components/input/Select";
//services
import { getSales } from "../../../../../services/Contracts/getSales";
// utils
import { formatDate, formatIsoDate } from "../../../../../utils/formatDate";
import { useAppContext } from "../../../../../context/AppContext";
import { useOptionsSelect } from "../../../../../hooks/useOptionsSelect";
import { useFiltersContext } from "../../../../../context/FiltersContext";

const Proposals = (id) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [table, setTable] = useState();

  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const form = useForm({
    shouldUnregister: false,
  });
  const { getValues, reset } = form;

  const errors = form.formState.errors;

  const {
    team,
    isLoadingTeams,
    selectTeam,
    members,
    brokers,
    imobs,
    loadingMembers,
    isLoadingImobs,
    isLoadingBroker,
  } = useOptionsSelect();
  const { id: enterpriseId } = useParams();
  const CACHE_EXPIRATION_TIME = 1 * 60 * 1000;
  const { lastNegotiationFilter, setLastNegotiationFilter } =
    useFiltersContext();

  const clearExpiredCache = (prefix) => {
    for (const key in sessionStorage) {
      if (key.startsWith(prefix)) {
        try {
          const item = JSON.parse(sessionStorage.getItem(key));
          if (item && item.timestamp) {
            if (Date.now() - item.timestamp > CACHE_EXPIRATION_TIME) {
              sessionStorage.removeItem(key);
            }
          }
        } catch (e) {
          sessionStorage.removeItem(key);
        }
      }
    }
  };

  useEffect(() => {
    const cachePrefix = `cache_proposal_${enterpriseId}_`;
    clearExpiredCache(cachePrefix);

    const filterKey = `lastNegotiationFilter_${enterpriseId}`;
    const savedFilterJSON = sessionStorage.getItem(filterKey);

    if (savedFilterJSON) {
      const savedFilter = JSON.parse(savedFilterJSON);
      setLastNegotiationFilter(savedFilter);
      reset(savedFilter);

      const resultCacheKey = `cache_proposal_${enterpriseId}_${JSON.stringify(
        savedFilter
      )}`;
      const cachedResultItem = sessionStorage.getItem(resultCacheKey);

      if (cachedResultItem) {
        const { data: cachedData, timestamp } = JSON.parse(cachedResultItem);
        if (Date.now() - timestamp < CACHE_EXPIRATION_TIME) {
          setTable(cachedData);
          setShowTable(true);
        }
      }
    }
  }, [enterpriseId, setLastNegotiationFilter, reset]);

  useEffect(() => {
    if (lastNegotiationFilter) {
      form.reset(lastNegotiationFilter);
    }
  }, [lastNegotiationFilter, form]);

  const onSubmit = async (data) => {
    const currentFormData = form.getValues();

    currentFormData.enterprise_id = id.id;
    const filterKey = `lastNegotiationFilter_${enterpriseId}`;
        sessionStorage.setItem(filterKey, JSON.stringify(currentFormData));
    setLastNegotiationFilter(currentFormData);
    const resultCacheKey = `cache_proposal_${enterpriseId}_${JSON.stringify(
      currentFormData
    )}`;
    const cachedResultItem = sessionStorage.getItem(resultCacheKey);
    if (cachedResultItem) {
      const { data: cachedData, timestamp } = JSON.parse(cachedResultItem);
      if (Date.now() - timestamp < CACHE_EXPIRATION_TIME) {
        setTable(cachedData);
        setShowTable(true);
        return;
      }
    }
     setLoading(true);
      const notification = toast.loading(
        "Por favor aguarde a consulta está sendo realizada..."
      );
    try {
      const response = await getSales(currentFormData, "proposal");
      //      console.log(response);
      // response.map((r) => {
      //   r.created_at = formatDate(r.created_at);
      //   return r;
      // });
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setTable(response);
      setShowTable(true);
      const itemToCache = { data: response, timestamp: Date.now() };
      sessionStorage.setItem(resultCacheKey, JSON.stringify(itemToCache));
    } catch (e) {
      //      console.log(e);
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const optionsStatus = [
    {
      label: "Proposta em Análise",
      value: 0,
    },
    {
      label: "Proposta recusada",
      value: 1,
    },
    {
      label: "Proposta aprovada",
      value: 2,
    },
  ];
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const columns = [
    { field: "id", header: "Nº Proposta" },
    { field: "name_cli", header: "Cliente" },
    { field: "broker", header: "Corretor" },
    {
      field: "created_at",
      header: "Data",
      body: (rowData) => formatDate(rowData.created_at),
    },
    { field: "block", header: nomenclature[0].value },
    { field: "land", header: nomenclature[1].value },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "Proposta em Análise";
            break;
          case 1:
            labelClass = "badge bg-danger";
            labelText = "Proposta recusada";
            break;
          case 2:
            labelClass = "badge bg-success";
            labelText = "Proposta aprovada";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginRight: "-35px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <Panel title="Filtro de Dados">
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-xl-3 col-md-4 mb-3">
                <Input
                  name="name_cli"
                  label="Nome do Cliente"
                  control={form.control}
                  errors={errors}
                />
              </div>
              <div className="col-xl-1 col-md-4 mb-3">
                <Input
                  name="sale_id"
                  control={form.control}
                  errors={errors}
                  label="Cod. Proposta"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="status"
                  label="Status"
                  control={form.control}
                  errors={errors}
                  options={optionsStatus}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="team_id"
                  label={isLoadingTeams ? "Carregando..." : `Time`}
                  control={form.control}
                  errors={errors}
                  onChange={(e) => selectTeam(e)}
                  disabled={isLoadingTeams ? true : false}
                  options={team}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="real_estate_id"
                  label={isLoadingImobs ? "Carregando..." : `Imobiliária`}
                  control={form.control}
                  errors={errors}
                  // onChange={(e) => selectTeam(e)}
                  disabled={isLoadingImobs ? true : false}
                  options={imobs}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="broker_id"
                  label={isLoadingBroker ? "Carregando..." : "Corretor"}
                  control={form.control}
                  options={brokers}
                  disabled={isLoadingBroker ? true : false}
                  errors={errors}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div
                className={`${
                  window.innerWidth <= 992 ? "w-25" : "col-xl-1 col-md-4"
                } text-center`}
              >
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
          </form>
        </Panel>
      </div>
      {showTable && (
        <div className="row">
          <Panel title={`Informações de Venda de ${nomenclature[1].value}`}>
            <>
              <hr className="my-4" />
              <div className="px-2 pb-3">
                <DataTable
                  rows={5}
                  paginator
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="single"
                  rowsPerPageOptions={[5, 25, 100]}
                  value={table}
                  emptyMessage={
                    <div style={{ textAlign: "center" }}>
                      Nenhuma Informação foi encontrada.
                    </div>
                  }
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  {columns.map((col) => (
                    <Column
                      sortable
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={col.body}
                    />
                  ))}
                  <Column
                    header="Abrir Proposta"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          className="btn btn-success btn-btn-sm"
                          onClick={() =>
                            navigate(`/proposal`, {
                              state: {
                                id: rowData.id,
                                enterpriseId: id,
                                status: rowData.status,
                                name: rowData.name || "",
                              },
                            })
                          }
                        >
                          <i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </button>
                      </div>
                    )}
                  />
                </DataTable>
              </div>
            </>
          </Panel>
        </div>
      )}
    </>
  );
};

export default Proposals;
